import { mount } from './ui/layout';
import { store } from './state/store';

// Apply saved theme before first render to avoid flash of unstyled content
const THEME_COLORS = { light: '#f5f1e9', dark: '#061a24' } as const;
function applyTheme(t: 'light' | 'dark') {
  document.documentElement.dataset.theme = t;
  const meta = document.getElementById('meta-theme-color') as HTMLMetaElement | null;
  if (meta) meta.content = THEME_COLORS[t];
}
applyTheme(store.theme.get());
store.theme.subscribe(applyTheme);

const root = document.getElementById('app');
if (!root) throw new Error('root #app not found');
mount(root);
